import React from 'react';

const LandingPage: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
            <h1 className="text-4xl font-bold text-center text-blue-600">Welcome to the ATIAM College Management System</h1>
            <p className="mt-4 text-lg text-gray-700">
                Your one-stop solution for managing college operations efficiently.
            </p>
            <div className="mt-6">
                <a href="/login" className="px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600">
                    Get Started
                </a>
            </div>
        </div>
    );
};

export default LandingPage;